import { request } from "/src/utils/index.js";

/**
 * 获取指定日期医保使用优惠券列表
 * @param {Object} params - 查询参数
 * @param {String} params.usedAt - 使用日期 (格式: 2026-07-20)
 * @param {String} params.feeType - 费用类型 (医保)
 */
export function GetMedicalInsuranceCouponList(params) {
  return request.get("/sdbs/customer/coupon/list/used", { params });
}

/**
 * 获取指定日期的医保数据
 * @param {Object} params - 查询参数
 * @param {String} params.date - 日期 (格式: 2026-7-20)
 */
export function GetMedicalInsuranceOrderList(params) {
  return request.get("/ext/consumption/order/list", { params });
}

/**
 * 关联医保订单
 * @param {Object} data - 请求参数
 * @param {String} data.Uuid - 优惠券UUID
 * @param {String} data.orderId - 订单ID
 * @param {String} data.orderItemId - 订单项ID
 */
export function LinkMedicalOrder(data) {
  return request.post("/sdbs/customer/coupon/ext/link", data);
}

/**
 * 取消关联医保订单
 * @param {Object} data - 请求参数
 * @param {String} data.uuid - 优惠券UUID
 */
export function UnlinkMedicalOrder(data) {
  return request.post("/sdbs/customer/coupon/ext/unlink", data);
}

/**
 * 优惠券重置
 * @param {Object} data - 请求参数
 * @param {String} data.uuid - 优惠券UUID
 */
export function ResetCoupon(data) {
  return request.post("/sdbs/customer/coupon/reset", data);
}